import { AppNames } from '../appNames.model';

export const FLEET_VEHICLE_ORDERS_LIST = `/${AppNames.ORGANIZATIONS}/:organizationsId/orders`;
export const FLEET_VEHICLE_ORDERS_DETAILS = `/${AppNames.ORGANIZATIONS}/:organizationsId/orders/:ordersId`;
export const FLEET_NOTIFICATIONS_LIST = `/${AppNames.FLEET}/list/notifications`;
export const FLEET_VEHICLE_LIST_DETAILS = `/${AppNames.FLEET}/vehicle/details`;
export const FLEET_PERIPHERALS_LIST = `/${AppNames.ORGANIZATIONS}/:organizationsId/peripherals`;
export const FLEET_DRIVERS_LIST = `/${AppNames.FLEET}/drivers/list`;
export const FLEET_DRIVERS_LIST_DETAILS = `/${AppNames.FLEET}/drivers/details`;
export const FLEET_DRIVERS_LIST_DETAILS_CHARGE_SESSION = `/${AppNames.FLEET}/drivers/details/chargeSession`;
export const FLEET_PENDING_VEHICLES_LIST = `/${AppNames.FLEET}/vehicle/list/pending`;
//TODO: update when advisor navConfig is defined within navDrawer.config file
export const ADVISOR_VEHICLE_LIST = `/${AppNames.LEGACY}/vehicle/list`;
export const ADVISOR_PENDING_VEHICLES_LIST = `/${AppNames.LEGACY}/vehicle/list/pending`;
export const ORGANIZATIONS_CUSTOM_VIDEO_REQUEST_LIST = `/${AppNames.ORGANIZATIONS}/:organizationsId/safety/custom-video`;
export const ORGANIZATIONS_CUSTOM_VIDEO_DETAILS = `/${AppNames.ORGANIZATIONS}/:organizationsId/safety/custom-video/:clipId`;
